import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { showModal } from 'appSrc/redux/actions';
import { Icon } from 'appSrc/components/UI';
import AspectRatio from 'react-aspect-ratio';
import style from './styles/style.module.css';

class TheaterPlayIcon extends PureComponent {
    playMovie = ( e ) => {
        e.preventDefault();
        if( this.props.youtubeId ) {
            this.props.playMovie( this.props.youtubeId, this.props.metaData );
        }
    }
    render() {
        var className = `${ style.playIconContainer } ${ this.props.className }`.trim();
        var widthStyle = {};
        if( this.props.size ) {
            widthStyle.width = this.props.size + 'px';
        }

        return (
            <div className={ className } onClick={ this.playMovie } style={ this.props.style }>
                <div className={ style.playIcon }>
                    <div className={ style.iconSetting } style={ widthStyle }>
                        <AspectRatio ratio='1/1'>
                            <div  className={ style.iconWrapper }>
                                <Icon source='fontAwesome' icon='fas/faPlayCircle' />
                            </div>
                        </AspectRatio>
                    </div>
                    { this.props.label &&
                        <div className={ style.label }>{ this.props.label }</div>
                    }
                </div>
            </div>
        );
    }
}
TheaterPlayIcon.defaultProps = {
    className: '',
    youtubeId : null,
    size: null,
    style: {},
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        playMovie: ( youtubeId, metaData ) => {
            dispatch( showModal( 'movieTheater', { youtubeId: youtubeId, metaData: metaData } ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( TheaterPlayIcon );
